import { PickupFormApiRequest } from "@/data/payload/api/PickupApiRequest";
import { PickupSubmitPayload } from "./types";

export class PickupRequestSubmitMapper {
  // Maps form submit payload to API request model
  public clientId = "";
  public clientParentId = "";
  public clientRef = "";

  public toRequest(payload: PickupSubmitPayload): PickupFormApiRequest {
    return new PickupFormApiRequest({
      clientId: this.clientId || payload.clientId,
      clientParentId: this.clientParentId || payload.clientParentId,
      client3lc: payload.client3lc,
      clientRef: this.clientRef || payload.clientRef,
      origin: payload.origin,
      pickupCorporateAddressId: payload.pcaId,
      pickupAddress: payload.pickupAddress,
      courierNote: payload.courierNote,
      geoloc: payload.geoloc,
      pickupDate: payload.pickupDate,
      pickupTime: payload.pickupTime,
      serviceCode: payload.serviceCodes.join(","),
      estimateTotalKoli: payload.estKoli,
      estimateTotalTonase: payload.estWeight,
      pickupType: payload.pickupType,
      clientPhoneNumber: payload.clientPhoneNumber,
      specialHandling: [...payload.specialHandling],
      sttNos: payload.sttNos
    });
  }
}
